<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-2" d="m10.25,10.48l8.58,61.32c.62,4.42,4.4,7.71,8.87,7.71h34.59c4.47,0,8.25-3.29,8.87-7.71l8.58-61.32"/>
  <path class="cls-1" d="m48.32,19.55l-.04,5.72c2.25.22,4.37.67,6.36,1.34,1.99.67,3.69,1.51,5.1,2.53l-2.7,7.41c-1.52-1.08-3.31-1.95-5.39-2.58-2.08-.64-4.18-.97-6.33-.98-2.15-.02-3.66.27-4.53.85-.87.59-1.31,1.31-1.32,2.17,0,.73.29,1.35.87,1.85.59.5,1.66.94,3.21,1.3l5.87,1.29c6.36,1.46,9.53,4.94,9.49,10.41-.02,2.91-1.02,5.37-2.99,7.38-1.97,2.01-4.61,3.32-7.9,3.92l-.04,5.98-7.22-.05.04-5.82c-1.8-.22-3.52-.67-5.16-1.33-1.64-.67-2.99-1.5-4.06-2.47l2.6-6.94c1.24.98,2.71,1.74,4.4,2.29,1.7.55,3.51.83,5.45.85,1.8.01,3.21-.31,4.22-.96,1.01-.65,1.52-1.49,1.52-2.54,0-.69-.28-1.28-.87-1.75-.58-.47-1.62-.89-3.11-1.24l-5.86-1.34c-6.46-1.47-9.68-4.86-9.64-10.2.02-2.94,1.02-5.4,3.01-7.36,1.99-1.96,4.58-3.22,7.77-3.79l.04-5.98,7.22.05Z"/>
</svg>
</template>

<script>
export default {
    name: "PriceBucketsIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #59c5c7;
  }
  .cls-2 {
    fill: none;
    stroke: #0b5e73;
    stroke-linecap: round;
    stroke-miterlimit: 10;
    stroke-width: 4px;
  }
</style>